import { User } from './../../../auth/_models/user';
import { SessionService } from './../../../auth/_services/session.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-nav, [app-header-nav]',
  templateUrl: './header-nav.component.html',
})
export class HeaderNavComponent implements OnInit {

  private user: User;

  constructor(
    private _sessionService: SessionService,
  ) { }

  ngOnInit() {
    this._sessionService.getUser().subscribe(user => {
      this.user = user;
    });
  }

  isRight(rights: Array<string>): boolean {

    if (this.user) {
      const right = this.user.right;

      if (rights.indexOf(right.key) >= 0) {
        return true;
      }

    }

    return false;

  }

}
